import { adminHttpClient } from '../../../commons/adminHttpClient'

export type PerksAllowanceTotalResponse = {
  allowancesOfferedToDate: number
  reimbursementsDue: number
  reimbursementsToDate: number
  remainingUnusedAllowance: number
}

const getPerksAllowanceTotal = (planPeriodId: string): Promise<PerksAllowanceTotalResponse> => {
  return adminHttpClient.get(
    `/AdminDashboard/Perks/Reimbursements/GetPerksAdminDashboardReimbursementStatistics/${planPeriodId}`,
  )
}

export default getPerksAllowanceTotal
